import { useEffect, useState } from "react";

const VariantSelector = ({ product, setSelectedVariant }) => {
  const [selectedAttributes, setSelectedAttributes] = useState({});

  const variants = product?.product?.attributes;

  // Initialize with first variant's attributes when component mounts
  useEffect(() => {
    if (Array.isArray(variants) && variants.length > 0 && Object.keys(selectedAttributes).length === 0) {
      const firstVariant = variants[0];
      const initialAttributes = {};
      
      // Get all attribute keys excluding non-attribute fields
      const attributeKeys = Object.keys(firstVariant).filter(
        (key) => key !== "other_attributes" && key !== "_id"
      );
      
      // Set initial attributes from first variant
      attributeKeys.forEach(key => {
        if (firstVariant[key]) {
          initialAttributes[key] = firstVariant[key];
        }
      });
      
      setSelectedAttributes(initialAttributes);
      setSelectedVariant(firstVariant);
    }
  }, [variants, selectedAttributes, setSelectedVariant]);

  // Dynamically match variant based on selectedAttributes
  useEffect(() => {
    if (Array.isArray(variants) && variants.length > 0 && Object.keys(selectedAttributes).length > 0) {
      const matched = variants.find((variant) =>
        Object.entries(selectedAttributes).every(
          ([key, value]) => variant[key] === value
        )
      );
      if (matched) {
        setSelectedVariant(matched);
      }
    }
  }, [selectedAttributes, setSelectedVariant, variants]);

  if (!Array.isArray(variants) || variants.length === 0) {
    return null; // No variants — nothing to render
  }

  // Get all attribute keys excluding non-attribute fields
  const attributeKeys = Object.keys(variants[0]).filter(
    (key) => key !== "other_attributes" && key !== "_id"
  );

  return (
    <div className="variant-selector mt-3">
      {attributeKeys.map((attrKey) => {
        const options = [
          ...new Set(variants.map((item) => item[attrKey])),
        ];

        return (
          <div key={attrKey} className="mb-4">
            <h6 className="text-uppercase fw-bold mb-3" style={{ fontSize: '0.85rem', letterSpacing: '1px', color: '#6c757d' }}>
              Select {attrKey}
            </h6>
            <div className="d-flex gap-2 flex-wrap">
              {options.map((option) => {
                const isSelected = selectedAttributes[attrKey] === option;
                return (
                  <div
                    key={option}
                    onClick={() =>
                      setSelectedAttributes((prev) => ({
                        ...prev,
                        [attrKey]: option,
                      }))
                    }
                    className="variant-option-item"
                    style={{
                      padding: "8px 16px",
                      border: isSelected ? "2px solid #dc3545" : "1px solid #dee2e6",
                      borderRadius: "8px",
                      textAlign: "center",
                      cursor: "pointer",
                      minWidth: "70px",
                      fontSize: "0.9rem",
                      fontWeight: isSelected ? "600" : "400",
                      backgroundColor: isSelected ? "rgba(220, 53, 69, 0.05)" : "white",
                      color: isSelected ? "#dc3545" : "#495057",
                      transition: "all 0.2s ease",
                      boxShadow: isSelected ? "0 2px 8px rgba(220, 53, 69, 0.15)" : "none"
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.borderColor = "#adb5bd";
                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.borderColor = "#dee2e6";
                        e.currentTarget.style.backgroundColor = "white";
                      }
                    }}
                  >
                    {option}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VariantSelector;
